module.exports = __webpack_public_path__ + "static/media/6.2867bed9.jpg";